<template>
  <div>
    <transition name="fade">
      <div v-if="$parent.showPopup" class="popup">
        <div @click="$parent.showPopup = false" class="offclick"></div>
        <div class="holder">
          <p @click="$parent.showPopup = false" class="close">x</p>

          <transition name="fade-quick">
            <div v-if="$parent.status == 'submit'">
              <p class="title">Login to your account</p>
              <div class="inputs">
                <div class="input full">
                  <label>Email Address</label>
                  <input
                    type="text"
                    placeholder="Type here"
                    v-model="user.email"
                  />
                </div>
                <div class="input full">
                  <label>
                    Password
                    <span class="required">*</span>
                  </label>
                  <input type="password" v-model="user.password" />
                </div>
                <div class="input full">
                  <p v-if="feedback" class="error">{{ feedback }}</p>
                </div>
                <transition name="fade-quick">
                  <div v-if="!loading" class="btns">
                    <button @click="validate()" class="btn">Login</button>
                    <button @click="forgotPassword" class="btn text_btn">
                      Forgot Password
                    </button>
                  </div>
                </transition>
                <transition name="fade-quick">
                  <div class="btns" v-if="loading">
                    <img class="login-loader" src="@/assets/img/loader.gif" />
                  </div>
                </transition>
              </div>
            </div>
          </transition>
          <transition name="fade-quick"></transition>

          <template v-if="$parent.forms && $parent.popupType == 'email'">
            <p class="title">Choose a form to send to your employees</p>
            <div class="inputs survey-forms">
              <div class="input full btm-space">
                <v-select
                  :options="$parent.forms"
                  label="title"
                  :clearable="false"
                  placeholder="Select a form here..."
                  v-model="$parent.form"
                ></v-select>
              </div>
              <div class="input">
                <label>Email</label>
                <div class="switch-holder">
                  <switches v-model="send_email"></switches>
                </div>
                <!-- <input type="checkbox" v-model="delivery_types" value="email" /> -->
              </div>
              <div class="input">
                <label>Text Message</label>
                <div class="switch-holder">
                  <switches v-model="send_text"></switches>
                </div>
                <!-- <input type="checkbox" v-model="delivery_types" value="phone" /> -->
              </div>
              <button
                :class="{ hide: !$parent.form }"
                :style="button_valid"
                :disabled="!delivery_types.length"
                @click="sendSurvey()"
                class="btn round-btn"
              >
                Send
              </button>
            </div>
          </template>
          <template v-else-if="$parent.forms && $parent.popupType == 'bulk'">
            <p class="title">Choose a form to send to your employees</p>
            <div class="inputs survey-forms">
              <div class="input full">
                <v-select
                  :options="$parent.forms"
                  label="title"
                  :clearable="false"
                  v-model="$parent.form"
                ></v-select>
              </div>
              <button @click="$parent.sendBulkEmail()" class="btn round-btn">
                Send
              </button>
            </div>
          </template>
          <template
            v-else-if="
              $parent.popupType == 'scheduled' ||
              $parent.popupType == 'scheduled_all'
            "
          >
            <div class="inputs survey-forms">
              <div
                v-if="$parent.popupType == 'scheduled_all'"
                class="input full"
              >
                <p class="subtitle">Filter Employees By Location (optional)</p>
                <v-select
                  :options="locations"
                  :reduce="(l) => l.id"
                  label="name"
                  v-model="$parent.selected_location"
                ></v-select>
              </div>
            </div>
            <div class="inputs survey-forms">
              <div class="input full">
                <p class="subtitle">Choose the type of reoccurrence</p>
                <v-select
                  :options="[
                    'Every day',
                    'Every weekday',
                    'Select specific days of the week',
                  ]"
                  :clearable="false"
                  v-model="$parent.reoccurrence_type"
                ></v-select>
                <v-select
                  multiple
                  class="multiple"
                  v-model="$parent.selected_dates"
                  label="day"
                  :reduce="(d) => d.code"
                  :options="[
                    {
                      day: 'Monday',
                      code: '00',
                    },
                    {
                      day: 'Tuesday',
                      code: '01',
                    },
                    {
                      day: 'Wednesday',
                      code: '02',
                    },
                    {
                      day: 'Thursday',
                      code: '03',
                    },

                    {
                      day: 'Friday',
                      code: '04',
                    },
                    {
                      day: 'Saturday',
                      code: '05',
                    },
                    {
                      day: 'Sunday',
                      code: '06',
                    },
                  ]"
                  v-if="
                    $parent.reoccurrence_type ==
                    'Select specific days of the week'
                  "
                ></v-select>

                <div class="inputs survey-forms">
                  <div class="input full btm-space">
                    <p class="subtitle">
                      Choose a form to send to your employees
                    </p>
                    <v-select
                      :options="$parent.forms"
                      label="title"
                      :clearable="false"
                      v-model="$parent.form"
                    ></v-select>
                  </div>
                </div>
                <div v-if="$parent.popupType == 'scheduled_all'" class="inputs">
                  <div class="input">
                    <label>Email</label>
                    <div class="switch-holder">
                      <switches v-model="$parent.send_email"></switches>
                    </div>
                    <!-- <input type="checkbox" v-model="delivery_types" value="email" /> -->
                  </div>
                  <div class="input">
                    <label>Text Message</label>
                    <div class="switch-holder">
                      <switches v-model="$parent.send_text"></switches>
                    </div>
                    <!-- <input type="checkbox" v-model="delivery_types" value="phone" /> -->
                  </div>
                </div>
              </div>
              <button
                @click="$emit('save-user-reminder')"
                class="btn round-btn"
              >
                Set
              </button>
            </div>
          </template>
          <template v-else-if="$parent.popupType == 'bulk_delete'">
            <p class="title">Select employees you wish to delete.</p>
            <div class="select_all">
              <input class="employee_delete_checkbox" type="checkbox" id="all" value="all" v-model="$parent.confirmAllForDeletion">
              <label for="all">Select All</label>
            </div>
            <div class="delete_employee_list">
              <div v-for="(e, i) in $parent.employeesToDelete" :key="i">
                <div class="employee_details">
                  <input
                    class="employee_delete_checkbox"
                    :id="e.id"
                    :value="e.id"
                    v-model="$parent.employeesConfirmedForDeletion"
                    type="checkbox"
                    number
                  />
                  <div class="">
                    {{ e.first_name }} {{ e.last_name }}: {{ e.email }}
                    {{ e.phone_number }}
                  </div>
                </div>
              </div>
            </div>
            <div class="input full">
              <button
                class="btn round-btn"
                @click="$parent.handleBulkEmployeeDelete"
              >
                Confirm
              </button>
            </div>
          </template>
          <slot v-else></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import firebase from "firebase";
import Switches from "vue-switches";
import Swal from "sweetalert2";

export default {
  name: "cart-popup",
  components: {
    Switches,
  },
  props: ["locations"],
  data() {
    return {
      send_text: false,
      send_email: true,
      user: {
        email: null,
        password: null,
      },
      loading: false,
      feedback: null,
      delivery_types: [],
    };
  },
  computed: {
    button_valid() {
      this.delivery_types = [];
      if (this.send_text) this.delivery_types.push("phone");
      if (this.send_email) this.delivery_types.push("email");
      if (this.delivery_types.length) {
        return {};
      } else {
        return { opacity: "30%", "pointer-events": "none" };
      }
    },
  },
  methods: {
    sendSurvey() {
      if (true) {
        let loader = this.$loading.show({
          container: null,
          canCancel: false,
        });
        this.$parent.delivery_types = this.delivery_types;
        this.$parent.sendSurvey().then(() => {
          loader.hide();
          Swal.fire("The form has been sent!");
        });
      } else {
      }
    },
    validate() {
      this.loading = true;
      this.login();
    },
    login() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.user.email, this.user.password)
        .then((user) => {
          setTimeout(() => {
            this.feedback = null;
            this.loading = false;
            this.goTo("/dashboard");
            this.$parent.showPopup = false;
          }, 500);
        })
        .catch((err) => {
          this.user.email = null;
          this.user.password = null;
          this.loading = false;
          this.feedback = err.message;

          setTimeout(() => {
            this.feedback = null;
          }, 3000);
        });
    },
    forgotPassword() {
      this.$parent.showPopup = false;
      this.goTo("/forgot-password");
    },
  },
};
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(23, 38, 43, 0.76);
}

.login-loader {
  height: 50px;
  display: block;
  width: auto !important;
}

.title {
  font-size: 30px;
  font-weight: bold;
  font-family: "SFProDisplay", sans-serif;
  margin-top: 0;
}

.subtitle {
  margin: 0;
  font-weight: bold;
  margin-bottom: 5px;
}

.offclick {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
}

.holder {
  position: relative;
  z-index: 2;
  padding: 50px;
  width: 500px;
  background-color: white;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  max-height: 600px;
  overflow: auto;
}

.not_found .holder {
  max-height: 100%;
  overflow: auto;
}

.holder input {
  width: 100%;
  box-sizing: border-box;
}

.holder .txt_btn {
  font-size: 23px;
}

.thanks {
  text-align: center;
}

.loader {
  width: 200px !important;
  margin: auto;
}

.holder {
  padding: 50px;
}

.holder p {
  line-height: 1.2;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade_delay-enter-active,
.fade_delay-leave-active {
  transition: opacity 0.5s;
  transition-delay: 0.5s;
}
.fade_delay-enter, .fade_delay-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.close {
  font-size: 25px;
  font-weight: bold;
  opacity: 0.4;
  padding: 10px 20px;
  margin: 0;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.btns {
  width: 100%;
}

.popup.survey-forms .inputs {
  width: 100%;
  margin-bottom: 100px;
}

.popup .inputs .btn {
  margin-top: 20px;
}

@media screen and (max-width: 700px) {
  .holder {
    padding: 30px;
  }
}

.btn.hide {
  opacity: 0.3;
  pointer-events: none;
}

.delete_employee_list {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.employee_details,
.select_all {
  display: flex;
  flex-direction: row;
}

.employee_delete_checkbox {
  width: 20px !important;
}
</style>
